import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';

import { Alert, Button } from 'components/Common';
import { LoginLayout } from 'components';

export class ForgotPassword extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    status: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = { email: '' };
  }

  handleChangeEmail = event => {
    this.setState({ email: event.target.value });
  };

  handleSubmit = event => {
    this.props.onSubmit(this.state.email);

    event.preventDefault();
  };

  renderError() {
    const { status } = this.props.status.error.response;

    const description =
      status === 404
        ? this.props.t('login.forgotPassword.errors.accountNotFound')
        : this.props.t('general.errors.default');

    return <Alert description={description} />;
  }

  render() {
    return (
      <LoginLayout
        title={this.props.t('login.forgotPassword.title')}
        description={this.props.t('login.forgotPassword.description')}
      >
        {this.props.status.error && this.renderError()}

        <form className="login__form" onSubmit={this.handleSubmit}>
          <label htmlFor="email">
            {this.props.t('login.email.form.email.label')}
          </label>
          <input
            name="email"
            type="email"
            placeholder={this.props.t('login.email.form.email.placeholder')}
            value={this.state.email}
            onChange={this.handleChangeEmail}
          />

          <Button type="submit" full isLoading={this.props.status.isLoading}>
            {this.props.t('login.forgotPassword.submit')}
          </Button>
        </form>

        <Link to="/login-email">&larr; {this.props.t('general.back')}</Link>
      </LoginLayout>
    );
  }
}

export default translate()(ForgotPassword);



// WEBPACK FOOTER //
// ./src/components/ForgotPassword/ForgotPassword.js